export const PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.cajobportal.app";

export const WHATSAPP_COMMUNITY_URL =
  "https://chat.whatsapp.com/E9MIMEtvZCG9HcW6gfl4Vi";
